/**
 * Created by Ning Jiang on 2022-06-15.
 */

import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {Serial} from "../Serial";
import {SerialSound} from "../sound/SerialSound";

export class WinCapIdlePresentation implements FlowStatePresentation {

    constructor() {}

    public async start(flowStateController:FlowStateController) {
        // Serial.initialCountUp.remove();
        // Serial.bigWinCountUp.remove();
        // Serial.waysWon.remove();
        // SlotGame.keypadPlugin.hide();
        Serial.keypadPlugin.setZeroBetSpinCounter(-1);
        Serial.background.tweenDimmer(0.8, 0.3);
        Serial.xBetController.buttonsVisible = false;
        SerialSound.fadeMusic(0, 1);

        const level = Serial.model.isRestore ? Serial.model.parsedInitData.maxWinLevel : Serial.model.parsedGameData.maxWinLevel;
        // await Serial.winCapController.playWinCapLevel();
        if(!Serial.model.isRestore) { // do not play when restore
            await Serial.winCapController.playWinPresentation(level);
        }

        Serial.winCapController.playPickLevel(level, () => {
            flowStateController.finish();
        });
    }
}